import Vue from 'vue';
import Router from 'vue-router';

const Login = () => import('../views/Login.vue');
const Signup = () => import('../views/Signup.vue');
const CreateUser = () => import('../views/CreateUser.vue');
const ExternalFlow = () => import('../views/ExternalFlow.vue');
const PhoneVerify = () => import('../views/PhoneVerify.vue');
const Document = () => import('../views/Document.vue');
const DocumentIdentityCard = () => import('../views/DocumentIdentityCard.vue');
const ManualDocumentIdentity = () =>
  import('../views/ManualDocumentIdentity.vue');
const DocumentDrivingLicense = () =>
  import('../views/DocumentDrivingLicense.vue');
const DocumentSelfie = () => import('../views/DocumentSelfie.vue');
const ManualDocumentSelfie = () => import('../views/ManualDocumentSelfie.vue');
const GeneralInformation = () => import('../views/GeneralInformation.vue');
const MembershipAndPayment = () => import('../views/MembershipAndPayment.vue');
const Membership = () => import('../views/Membership.vue');
const Payment = () => import('../views/Payment.vue');
const Finish = () => import('../views/Finish.vue');
const Error = () => import('../views/Error.vue');
const TocId = () => import('../views/TocId.vue');
const Kushki = () => import('../views/Kushki.vue');
const ValidatePayment = () => import('../views/ValidatePayment.vue');
const PaymentError = () => import('../views/PaymentError.vue');

const ResetPassword = () => import('../views/ResetPassword.vue');
const ResetPasswordToken = () => import('../views/ResetPasswordToken.vue');
const ResetPasswordMessage = () => import('../views/ResetPasswordMessage.vue');
const NewPassword = () => import('../views/NewPassword.vue');
const SetPin = () => import('../views/SetPin.vue');
const Redirect = () => import('../views/Redirect.vue');
const Forbidden = () => import('../views/Forbidden.vue');
const DEV = () => import('../views/DEV.vue');

import store from '../store';
import isTheRightStep from './middleware/isTheRightStep.js';
import auth from './middleware/auth.js';
import guest from './middleware/guest.js';
import notFound from './middleware/notFound.js';

import middlewarePipeline from './middlewarePipeline';

Vue.use(Router);
const routes = [
  {
    path: '/',
    redirect: { name: 'login' },
  },
  {
    path: '/login',
    component: Login,
    name: 'login',
    meta: {
      title: 'Iniciar sesión',
      middleware: [guest],
    },
  },
  {
    path: '/admin/sign-up',
    component: Signup,
    name: 'SIGN_UP',
    meta: {
      title: 'Registro',
      middleware: [guest],
    },
  },
  {
    path: '/admin/sign-up/forget-password',
    component: ResetPassword,
    name: 'FORGET_PASSWORD',
    meta: {
      title: 'Contraseña olvidada',
      middleware: [guest],
    },
  },
  {
    path: '/token',
    component: ResetPasswordToken,
    name: 'FORGET_PASSWORD_TOKEN',
    meta: {
      title: 'Ingresa tu token',
      middleware: [guest],
    },
  },
  {
    path: '/message',
    component: ResetPasswordMessage,
    name: 'FORGET_PASSWORD_MESSAGE',
    meta: {
      title: 'Ingresa tu token',
      middleware: [guest],
    },
  },
  {
    path: '/admin/sign-up/new-password',
    component: NewPassword,
    name: 'NEW_PASSWORD',
    meta: {
      title: 'Nueva contraseña',
      middleware: [guest],
    },
  },
  {
    path: '/admin/sign-up/create-user',
    component: CreateUser,
    name: 'CREATE_USER',
    meta: {
      middleware: [isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/external',
    component: ExternalFlow,
    name: 'CREATE_EXTERNAL',
    meta: {
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/phone-number',
    component: CreateUser,
    name: 'PHONE_NUMBER',
    meta: {
      middleware: [auth, isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/phone-verify',
    component: PhoneVerify,
    name: 'PHONE_VERIFY',
    meta: {
      middleware: [auth, isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/document',
    component: Document,
    name: 'DOCUMENT',
    meta: {
      middleware: [auth, isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/document-identity',
    component: DocumentIdentityCard,
    name: 'documentIdentityCard',
    meta: {
      middleware: [auth, isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/manual-document-identity',
    component: ManualDocumentIdentity,
    name: 'MANUAL_DOCUMENT',
    meta: {
      middleware: [auth, isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/document-license',
    component: DocumentDrivingLicense,
    name: 'DRIVE_DOCUMENT',
    meta: {
      middleware: [auth, isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/document-selfie',
    component: DocumentSelfie,
    name: 'TOC_SELFIE',
    meta: {
      middleware: [auth, isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/manual-document-selfie',
    component: ManualDocumentSelfie,
    name: 'MANUAL_DOCUMENT_SELFIE',
    meta: {
      middleware: [auth, isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/general-information',
    component: GeneralInformation,
    name: 'GENERAL_INFORMATION',
    meta: {
      middleware: [auth, isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/membership-and-payment',
    component: MembershipAndPayment,
    name: 'membershipAndPayment',
  },
  {
    path: '/admin/sign-up/membership',
    component: Membership,
    name: 'MEMBERSHIP',
    meta: {
      middleware: [auth, isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/payment',
    component: Payment,
    name: 'PAYMENT',
    meta: {
      middleware: [auth, isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/finish',
    component: Finish,
    name: 'REVIEW',
    meta: {
      middleware: [auth, isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/error-toc-autocaptura',
    component: Error,
    name: 'error-autocaptura',
    meta: {
      middleware: [auth],
      title: 'TOC Error',
    },
  },
  {
    path: '/admin/sign-up/error-toc-liveness',
    component: Error,
    name: 'error-liveness',
    meta: {
      middleware: [auth],
      title: 'TOC Error',
    },
  },
  {
    path: '/admin/sign-up/critical-toc-error',
    component: Error,
    name: 'critical-error',
    meta: {
      middleware: [auth],
      title: 'TOC Error',
    },
  },
  {
    path: '/admin/sign-up/critical-unknown-toc-error',
    component: Error,
    name: 'critical-unknown-error',
    meta: {
      middleware: [auth],
      title: 'TOC Error',
    },
  },
  {
    path: '/admin/sign-up/document-identity-card',
    component: TocId,
    name: 'TOC_ID',
    meta: {
      middleware: [auth, isTheRightStep],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/kushki',
    component: Kushki,
    name: 'KUSHKI',
    meta: {
      middleware: [auth],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/payment/kushki',
    component: ValidatePayment,
    meta: {
      middleware: [auth],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/payment/oneclick',
    component: ValidatePayment,
    meta: {
      middleware: [auth],
      title: 'Registro',
    },
  },
  {
    path: '/admin/sign-up/payment/error',
    component: PaymentError,
    name: 'PAYMENT_ERROR',
    meta: {
      middleware: [auth],
      title: 'Registro',
    },
  },
  {
    path: '/set-pin',
    component: SetPin,
    name: 'SET_PIN',
    meta: {
      middleware: [auth],
      title: 'Registro',
    },
  },
  {
    path: '/redirect',
    component: Redirect,
    name: 'REDIRECT',
    meta: {
      title: 'Redirigiendo',
    },
  },
  {
    path: '/forbidden',
    component: Forbidden,
    name: 'FORBIDDEN',
    meta: {
      title: 'Forbidden',
    },
  },
  {
    path: '/dev',
    component: DEV,
    name: 'DEV',
  },
  {
    path: '*',
    component: Login,
    name: '404',
    meta: {
      middleware: [notFound],
      title: 'No encontrado',
    },
  },
];
const router = new Router({
  routes,
  mode: 'history',
});
router.beforeEach((to, from, next) => {
  let appName = store.getters['visualResources/appName'];
  if (!appName) appName = '';
  document.title = to.meta.title
    ? `${appName}${appName ? ' - ' : ''}${to.meta.title}`
    : appName;

  if (!to.meta.middleware) {
    return next();
  }
  const middleware = to.meta.middleware;

  const context = {
    to,
    from,
    next,
    store,
  };
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});
export default router;
